import { combineRules } from 'fela';

import type { TRuleWithTheme } from '@/styles/theme';

interface ButtonStyleProps {
    dropdownOpen: boolean;
}

const transition: TRuleWithTheme = () => ({
    transitionDuration: '0.25s',
    transitionTimingFunction: 'ease-in-out',
    transitionProperty: 'all',
});

export const button: TRuleWithTheme<ButtonStyleProps> = combineRules(transition, ({ theme, dropdownOpen }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',

    padding: 0,
    margin: 0,

    border: 'none',

    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.43em',
    letterSpacing: '0.0143em',

    color: dropdownOpen ? theme.colors.accentSecondary : theme.colors.foregroundsPrimary,

    ':hover': {
        cursor: 'pointer',
    },
}));

export const caret: TRuleWithTheme<ButtonStyleProps> = combineRules(transition, ({ theme, dropdownOpen }) => ({
    color: dropdownOpen ? theme.colors.accentSecondary : theme.colors.foregroundsPrimary,
    transform: dropdownOpen ? 'scaleY(-1)' : 'scaleY(1)',
}));
